export default function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 px-4 md:px-6 bg-background-950">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">热播推荐</h2>
          <span className="text-xs text-foreground-500 bg-background-800/70 px-3 py-1 rounded-full">编辑精选</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="group rounded-2xl overflow-hidden bg-background-800/30 border border-background-700/20 hover:border-accent-500/30 transition-all cursor-pointer">
            <div className="relative h-56 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20key%20visual%20with%20emperor%20figure%20in%20dramatic%20pose%2C%20palace%20background%2C%20golden%20and%20crimson%20color%20scheme%2C%20cinematic%20lighting%2C%20epic%20film%20poster%20style&width=500&height=700&seq=carousel-1&orientation=portrait"
                alt="庆余年2 - 范闲归来"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/20 to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="text-[10px] font-semibold bg-accent-500 text-background-950 px-2 py-1 rounded-full">TOP 1</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">庆余年2</h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2">范闲假死归来，京都风云再起。朝堂权谋与江湖恩怨交织，一场关乎天下的大局缓缓拉开。</p>
              <div className="flex items-center gap-3 mt-3">
                <span className="text-xs text-accent-400">9.6分</span>
                <span className="text-xs text-foreground-600">全36集</span>
              </div>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-800/30 border border-background-700/20 hover:border-accent-500/30 transition-all cursor-pointer">
            <div className="relative h-56 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Mystery%20detective%20Chinese%20drama%20key%20visual%2C%20dark%20atmospheric%20scene%20with%20detective%20figures%20in%20ancient%20Chinese%20attire%2C%20foggy%20mountain%20background%2C%20suspenseful%20mood%2C%20cinematic%20film%20poster&width=500&height=700&seq=carousel-2&orientation=portrait"
                alt="唐朝诡事录之西行"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/20 to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="text-[10px] font-semibold bg-primary-500 text-background-950 px-2 py-1 rounded-full">TOP 2</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">唐朝诡事录之西行</h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2">苏无名与卢凌风西行探案，西域奇诡事件接连发生，真相背后隐藏着惊天秘密。</p>
              <div className="flex items-center gap-3 mt-3">
                <span className="text-xs text-accent-400">9.4分</span>
                <span className="text-xs text-foreground-600">全40集</span>
              </div>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-800/30 border border-background-700/20 hover:border-accent-500/30 transition-all cursor-pointer">
            <div className="relative h-56 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Romantic%20period%20Chinese%20drama%20key%20visual%20with%20female%20lead%20in%20elegant%20traditional%20dress%2C%20rainy%20night%20scene%2C%20emotional%20expression%2C%20soft%20dramatic%20lighting%2C%20poetic%20cinematic%20poster%20style&width=500&height=700&seq=carousel-3&orientation=portrait"
                alt="墨雨云间"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/20 to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="text-[10px] font-semibold bg-secondary-500/80 text-foreground-50 px-2 py-1 rounded-full">TOP 3</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">墨雨云间</h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2">薛芳菲重生归来，步步为营只为揭开当年真相。爱恨交织的权谋大戏，令人欲罢不能。</p>
              <div className="flex items-center gap-3 mt-3">
                <span className="text-xs text-accent-400">9.3分</span>
                <span className="text-xs text-foreground-600">全40集</span>
              </div>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-800/30 border border-background-700/20 hover:border-accent-500/30 transition-all cursor-pointer">
            <div className="relative h-56 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Crime%20thriller%20Chinese%20drama%20key%20visual%2C%20intense%20police%20characters%20in%20dark%20urban%20setting%2C%20dramatic%20high%20contrast%20lighting%2C%20gritty%20realistic%20style%2C%20powerful%20cinematic%20poster%20aesthetic&width=500&height=700&seq=carousel-4&orientation=portrait"
                alt="狂飙"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/20 to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="text-[10px] font-semibold bg-background-700/70 text-foreground-300 px-2 py-1 rounded-full">TOP 4</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">狂飙</h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2">从鱼贩到黑帮大佬，二十年的黑白交锋。扫黑除恶风暴席卷京海，正义终将到来。</p>
              <div className="flex items-center gap-3 mt-3">
                <span className="text-xs text-accent-400">9.8分</span>
                <span className="text-xs text-foreground-600">全39集</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}